import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=166ebcef&scoped=true&"
import script from "./pedidos.vue?vue&type=script&lang=js&"
export * from "./pedidos.vue?vue&type=script&lang=js&"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=166ebcef&prod&scoped=true&lang=css&"
import style1 from "./pedidos.vue?vue&type=style&index=1&id=166ebcef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ebcef",
  null
  
)

export default component.exports